import React from "react";
import { useParams } from "react-router-dom";
import HyroBreadcrumbs from "@hyro-components/hyro-breadcrumbs/HyroBreadcrumbs";
import { capitalize } from "@utils";
import { useDataProcessor } from "src/queries/hooks/dataProcessing";

const DataProcessingBreadcrumbs = () => {
  const { accountId, dataProcessorId } = useParams();
  const baseUrl = `/${accountId}/`;
  const { data: dataProcessor } = useDataProcessor({ accountId, dataProcessorId });

  const breadcrumbs = [
    capitalize(accountId).replace(/[_-]/, " "),
    "Data Processing",
    ...(dataProcessor?.name ? [dataProcessor.name] : [])
  ];

  return <HyroBreadcrumbs breadcrumbs={breadcrumbs} baseUrl={baseUrl} />;
};

export default DataProcessingBreadcrumbs;
